import { useState, useEffect } from 'react';
/** Components */
import Table from 'components/Table';
import Loader from 'components/Loader';
/** Services */
import { getAllInvoices } from 'services/clients';
/** Utils */
import { createToast } from 'utils/toast';
/** Constants */
import { INVOICES_HEAD_CELLS } from 'constants/clients';
/** Styles */
import './Facturas.scss';

const Facturas = ({ client }) => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllInvoices()
      .then(({ data }) => {
        console.log(111, data);
        const filteredInvoices = data.filter(
          ({ clientId }) => clientId === client
        );
        setInvoices(filteredInvoices);
        setLoading(false);
      })
      .catch(({ status }) => {
        setLoading(false);
        if (status === 401) {
          createToast({
            text: 'No tienes suficientes permisos',
            type: 'error',
          });
          return;
        }
        if (status === 404) {
          createToast({
            text: 'No existen facturas de clientes',
            type: 'error',
          });
          return;
        }

        createToast({ text: 'Algo ha salido mal', type: 'error' });
      });
  }, []);

  const mappedInvoices = invoices.map(
    ({
      invoiceNumber = '',
      date,
      // supplierName,
      basePrice,
      totalPrice,
      vat,
      id,
    }) => {
      return {
        ...(invoiceNumber
          ? { invoiceNumber }
          : { invoiceNumber: 'Sin nº de factura' }),
        ...(date ? { date } : { date: 'Sin fecha' }),
        // ...(supplierName
        //   ? { supplierName }
        //   : { supplierName: 'Sin proveedor' }),
        ...(basePrice ? { basePrice } : { basePrice: 'Sin precio base' }),
        ...(totalPrice ? { totalPrice } : { totalPrice: 'Sin precio total' }),
        ...(vat ? { vat } : { vat: 'Sin IVA' }),
        metadata: { fileId: id, key: 'clientInvoice' },
        ...(id && { id }),
      };
    }
  );

  return loading ? (
    <Loader />
  ) : (
    <>
      {invoices.length !== 0 ? (
        <Table
          rowsData={mappedInvoices}
          headCells={INVOICES_HEAD_CELLS}
          ignoreColumn="id"
          targetItem="id"
        />
      ) : (
        <div className="EmptyState">No hay facturas.</div>
      )}
    </>
  );
};

export default Facturas;
